import {SimpleList, List} from "react-admin";
import * as React from "react";

export const SystemSettingsList = (props) => {

    return (
        <List {...props}>
            <SimpleList
                primaryText={record => record.settingsName}
                secondaryText={record => record.settingsDesc}
            />
        </List>
    );
};

